import React from "react";
import BsPanelHeaderFilterControl from "components/panel/header/BsPanelHeaderFilterControl";
import Row from "components/layout/Row";
import Col from "components/layout/Col";
import {useTranslation} from "react-i18next";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";

const AllCustomerSupportFilters = (props) => {
  const {t} = useTranslation();
  const systemRef = React.createRef();

  return (
      <Row>
        <Col size="4">
          <BsPanelHeaderFilterControl>
            <TextField label={t('bicycle_reports.system_name_filter')}
                       ref={systemRef}
                       onChange={props.onHandleChange.bind(this, "systemName")}
                       value={props.fields["systemName"]}
                       className="form-control"/>
          </BsPanelHeaderFilterControl>
        </Col>
        <Col size="4">
          <BsPanelHeaderFilterControl>
            <FormControl className="form-control">
              <InputLabel id="status-label">{t('customer_support.status_filter')}</InputLabel>
              <Select
                  labelId="status-label"
                  id="status"
                  multiple
                  value={props.fields["status"]}
                  renderValue={(selected) => selected
                      .map(val => t('issue_status.' + val))
                      .join(', ')}
                  onChange={props.onHandleChange.bind(this, "status")}>
                <MenuItem value="CREATED">{t('issue_status.CREATED')}</MenuItem>
                <MenuItem value="ASSIGNED">{t('issue_status.ASSIGNED')}</MenuItem>
                <MenuItem value="IN_PROGRESS">{t('issue_status.IN_PROGRESS')}</MenuItem>
                <MenuItem value="DONE">{t('issue_status.DONE')}</MenuItem>
                <MenuItem value="CLOSED">{t('issue_status.CLOSED')}</MenuItem>
              </Select>
            </FormControl>
          </BsPanelHeaderFilterControl>
        </Col>
      </Row>
  )
}

export default AllCustomerSupportFilters;
